import { useMemo } from 'react';
import { getUtcDate, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

interface PlanTerminationPropertiesPayload {
  id: number;
  plan_id: number;
  termination_date: string;
  claim_last_date: string;
  coverage_end_date: string;
  hsa_transfer_of_assets: string;
}

export interface PlanTerminationProperties {
  id: string;
  planId: string;
  terminationDate: string;
  claimLastDate?: string;
  coverageEndDate?: string;
  hsaTransferOfAssets: string;
}

const planListFormatter = (data: PlanTerminationPropertiesPayload[]) =>
  data.map((item) => ({
    id: `${item?.id}`,
    planId: `${item?.plan_id}`,
    terminationDate: getUtcDate(item?.termination_date).format(DEFAULT_DATE_FORMAT),
    claimLastDate: item?.claim_last_date
      ? getUtcDate(item.claim_last_date).format(DEFAULT_DATE_FORMAT)
      : undefined,
    coverageEndDate: item?.coverage_end_date
      ? getUtcDate(item.coverage_end_date).format(DEFAULT_DATE_FORMAT)
      : undefined,
    hsaTransferOfAssets: item?.hsa_transfer_of_assets || '',
  }));

const QUERY_KEY = 'useGetEmployerPendingTerminationPlansQueryKey';

export const useGetEmployerPendingTerminationPlansQuery = (orgId?: string) => {
  const { isLoading, isSuccess, data, refetch } = useQuery(
    [orgId, QUERY_KEY],
    orgId
      ? () =>
          // TODO: the DTO type is missing
          api.get<PlanTerminationPropertiesPayload[]>(API_URL.PLANS_TERMINATION_PROPERTIES, {
            params: { organization_id: orgId },
          })
      : () => null
  );

  const formattedData = useMemo(() => {
    if (!data?.data) return [];

    return planListFormatter(data.data);
  }, [data]);

  return {
    data: data?.data,
    formattedData,
    isLoading,
    isSuccess,
    refetch,
  };
};
